import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { CryptoService } from './crypto.service';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteSessionsService {
  private cryptoService: CryptoService = new CryptoService();

  constructor(private http: HttpClient) { }

  // Create Call Center
  public createSiteSession(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-site-session/callcenter-create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public checkIntoExistingSession(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-site-session/callcenter-check-in', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public checkOut(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-site-session/callcenter-check-out', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public createManagerSiteSession(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-site-session/callcenter-management-create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public checkOutManager(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-site-session/callcenter-management-check-out', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public checkIfUserInSession(id) {
    return this.http.get(environment.apiUrl + 'api/ext-user-session/open-user-sessions/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getSiteSessionForWorkOrder(id) {
    return this.http.get(environment.apiUrl + 'api/ext-site-session/by-work-order/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getActiveSiteSessionByAsset(assetId) {
    return this.http.get(environment.apiUrl + 'api/ext-site-session/active-session-by-asset/' + assetId)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }


  public getRecentUserSessionfromOfflineBackup() {
    const fileName = 'Worker-Session-BackUp-' + new Date().toLocaleDateString() + '.csv';
    const dynamoUserSessionsApiKey = this.cryptoService.decryptText(localStorage.getItem(environment.keys.dynamoUserSessions));
    const getHeaders = new HttpHeaders()
      .set('x-api-key', dynamoUserSessionsApiKey)
      .set(environment.InterceptorSkipHeader, '');
    this.http.get(environment.dynamoUserSessionsUri, { headers: getHeaders, responseType: 'blob' }).subscribe((data) => {
      const fileURL = URL.createObjectURL(data);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = fileURL;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    });
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }


  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
